import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FaCarOn } from "react-icons/fa6";
import {
  genTemplateBodyDate,
  genTemplateBodyText,
} from "../../../../../components/utils/TableTemplateBodyGenerator";
import { Button } from "primereact/button";
import { format } from "date-fns";
import { confirmDialog } from "primereact/confirmdialog";
import { useLocation, useNavigate } from "react-router-dom";
import useIsMobile from "../../../../../hooks/useIsMobile";


const ListJadwal = (props) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const { listDataJadwalKeberangkatan, loading } = props;

  // handle ui event section

  const handleOnClickMulaiPengecekan = async (row) => {
    confirmDialog({
      message: `Memulai pengecekan untuk ${row.data_kendaraan.nomor_polisi} ?`,
      header: "Konfirmasi Mulai Pengecekan",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        const urlParams = new URLSearchParams(location.search);
        const key = urlParams.get("key");
        let url = `/transaksi/cek-keluar-masuk-trado/berangkat/${row.id}`;
        if (key) {
          const encodedKey = encodeURIComponent(key);
          url += `?key=${encodedKey}`;
        }
        if (isMobile) {
          navigate(url);
        } else {
          // open new tab
          window.open(url, "_blank");
        }
      },
    });
  };

  // custom ui section

  const tanggalPerkiraanBerangkatBodyTemplate = (row) =>
    genTemplateBodyDate({
      row,
      field: "tanggal_perkiraan_berangkat",
      format: "dd/MM/yyyy HH:mm",
    });
  const pemakaiBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_pemakai.nama" });
  const kendaraanBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_kendaraan.nomor_polisi" });
  const supirBodyTemplate = (row) => {
    return (
      <div className="col-start-start text-xs italic gap-2">
        <span>-{row.data_supir.nama}</span>
        {row.data_supir_pulang && <span>-{row.data_supir_pulang.nama}</span>}
      </div>
    );
  };
  const tujuanBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_tujuan.nama" });

  const trailerBodyTemplate = (row) => {
    return (
      <div className="col-start-start text-sm">
        <span>Berangkat: {row.data_trailer_berangkat?.nomor ?? "-"}</span>
        <span>Pulang: {row.data_trailer_pulang?.nomor ?? "-"}</span>
      </div>
    );
  };

  const mulaiPengecekanBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          className="row-start-center gap-2"
          onClick={() => handleOnClickMulaiPengecekan(row)}
        >
          <FaCarOn className="pb-[0.2rem]" />
          <span className="!text-xs"> MULAI CEK </span>
        </Button>
      </div>
    );
  };

  const deskripsiJadwalKeberangkatanSmallSizeBodyTemplate = (row) => {
    const {
      data_kendaraan,
      data_pemakai,
      data_supir,
      data_supir_pulang,
      data_tujuan,
      tanggal_transaksi,
      no,
    } = row;

    return (
      <div className="col-start-start py-2">
        <div className="row-start-center gap-2 w-full">
          <span className="text-slate-400 text-sm font-semibold"># {no}, </span>
          <span className="text-slate-400 text-sm font-semibold italic">
            {format(new Date(tanggal_transaksi), "dd/MM/yyyy HH:mm")}
          </span>
        </div>

        <div className="row-start-center gap-2 pt-3">
          <span>{data_kendaraan.jenis_mobil},</span>
          <span>{data_kendaraan.nomor_polisi}</span>
        </div>
        <div className="col-start-start pt-3">
          <div className="row-start-center text-sm italic gap-2">
            <span className="w-[4.5rem] text-right"> Pemakai: </span>
            <span className="font-bold">{data_pemakai.nama}</span>
          </div>
          <div className="row-start-center text-sm italic gap-2">
            <span className="w-[4.5rem] text-right"> Supir Berangkat: </span>
            <span className="font-bold">{data_supir.nama}</span>
          </div>
          <div className="row-start-center text-sm italic gap-2">
            <span className="w-[4.5rem] text-right"> Supir Pulang: </span>
            <span className="font-bold">{data_supir_pulang?.nama}</span>
          </div>
          <div className="row-start-center text-sm italic gap-2">
            <span className="w-[4.5rem] text-right"> Tujuan: </span>
            <span className="font-bold">{data_tujuan.nama}</span>
          </div>
        </div>

        <div className="row-end-start w-full pt-4 ">
          <Button
            className="row-start-center gap-2"
            onClick={() => handleOnClickMulaiPengecekan(row)}
          >
            <FaCarOn className="pb-[0.2rem]" />
            <span className="!text-xs"> MULAI CEK </span>
          </Button>
        </div>
      </div>
    );
  };

  if (!(listDataJadwalKeberangkatan && listDataJadwalKeberangkatan.length > 0)) {
    return null;
  }

  return (
      <div
        className={`elevated-card row-start-start w-100  wrap gap-4 !bg-indigo-100 !border-indigo-500 !border-2`}
      >
        <span className="text-sm font-semibold text-indigo-600">
          JADWAL KEBERANGKATAN
        </span>

        <div className={`col-center-center gap-2 w-100`}>
          {!isMobile && (
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              editMode="cell"
              cellClassName={"bg-blue-50"}
              value={listDataJadwalKeberangkatan}
            >
              <Column
                field="no"
                header="#"
                headerClassName="bg-indigo-300 w-[4rem]"
                className="text-right"
                alignHeader={"right"}
              />
              <Column
                header="Tanggal"
                headerClassName="bg-indigo-300"
                body={tanggalPerkiraanBerangkatBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header="Kendaraan"
                body={kendaraanBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header="Trailer"
                body={trailerBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header="Pemakai"
                body={pemakaiBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header="Supir"
                body={supirBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header="Tujuan"
                body={tujuanBodyTemplate}
              />
              <Column
                headerClassName="bg-indigo-300"
                header=""
                body={mulaiPengecekanBodyTemplate}
                alignHeader={"center"}
              />
            </DataTable>
          )}

          {isMobile && (
            <DataTable
              dataKey="id"
              className="w-100"
              loading={loading}
              showGridlines
              stripedRows
              editMode="cell"
              cellClassName={"bg-blue-50"}
              value={listDataJadwalKeberangkatan}
            >
              <Column
                header="Deskripsi"
                align={"center"}
                body={deskripsiJadwalKeberangkatanSmallSizeBodyTemplate}
              />
            </DataTable>
          )}
        </div>
      </div>
  );
};

export default ListJadwal;
